import React from 'react';
import styled from 'styled-components';

import Text from '@summer/ui-components/src/core/typography/Text';

import { Link } from 'components/shared/typography';

const SupportContact = () => {
  return (
    <LinkTextContainer small paragraph>
      Having trouble? Contact us at{' '}
      <Link underline inheritColor href="mailto:support@meetsummer.com">
        support@meetsummer.com
      </Link>{' '}
      and we&rsquo;ll get back to&nbsp;you.
    </LinkTextContainer>
  );
};

const LinkTextContainer = styled(Text)`
  margin-bottom: 24px;
  max-width: 360px;
  text-align: center;
`;

export default SupportContact;
